module.exports = __webpack_public_path__ + "static/media/iconTd.b823fe6a.svg";